export const EXCLUDED_NOTIFICATION_NAMES = [7, 5]
export const EXCLUDED_EMAIL_NOTIFICATION_NAMES = [2, 12, 13]
export const POSTS_PER_PAGE = 24
